import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { getNexusTokens } from '../theme/tokens';

/**
 * Centered page-level loading spinner (Phase 4.1).
 * Matches ClientScopedGate loading treatment on read-only pages.
 */
export default function PageLoadingState({
  minHeight = 360,
  message = null,
  sx,
}) {
  const theme = useTheme();
  const tokens = getNexusTokens(theme);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight,
        gap: 2,
        ...sx,
      }}
    >
      <CircularProgress />
      {message ? (
        <Typography variant="body2" sx={{ color: tokens.colors.text.secondary }}>
          {message}
        </Typography>
      ) : null}
    </Box>
  );
}
